import { ExplorerBarStore } from './types';

export const actionsSelector = (store: ExplorerBarStore) => store.actions;

export const explorerSelector = (store: ExplorerBarStore) => store.explorer;

export const activeClipIndexSelector = (store: ExplorerBarStore) =>
  store.activeClipIndex;
